import { Paper, Snackbar, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ICabecalho5D, IFertilizacaoOrganica } from "../../../Interfaces/cadernos/caderno5/interfaces5D";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { CustomSelect, CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import React, { useContext, useEffect, useState } from "react";
import { Alert } from "../../../Components/Alert/Alert";
import { StyledTableCell, StyledTableCellCabecalho, StyledTableHead, StyledTableRow } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { del, get, post } from "../../../Services/tokenConfig";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { func_print } from "../../../Func_genericas/func_print";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { confirm, tres_dois_dois, tres_um_dois, tres_um_quatro, tres_um_tres } from "../../../informacao_estatica";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { useLocation } from "react-router-dom";

interface IFertilizacaoOrganicaProps {
    total_quant3: number;
    cabecalho: ICabecalho5D | undefined;
    obj_organica: IFertilizacaoOrganica | undefined;
}

export const FertilizacaoOrganicaForm: React.FC<IFertilizacaoOrganicaProps> = ({
    cabecalho,
    total_quant3,
    obj_organica,
}) => {
    const auth = useContext(AuthContext);
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
    const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
    const [message, setMessage] = React.useState<string>("");

    const [rowsOrganica, setRowsOrganica] = useState<IFertilizacaoOrganica[]>([]);
    const [obj_editar, set_obj_editar] = React.useState<IFertilizacaoOrganica | undefined>();

    const [error_ferti_B, set_error_ferti_B] = useState<boolean>(false);
    const [openDeleteOrganica, setOpenDeleteOrganica] = React.useState<boolean>(false);
    const [createTable, setCreateTable] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

    const handleCloseDialog = () => {
        handle_fechar_nova_linha_limpar_campos()


        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    const calcula_b_A = (ferti_B: number, ferti_A: number) => {
        if (Number.isNaN(ferti_B) || Number.isNaN(ferti_A)) {
            return 0
        } else {
            if (ferti_A !== 0) {
                return (ferti_B / ferti_A) * 100

            } else {
                return 0

            }
        }
    }

    async function getOrganica() {
        try {
            let res = await get(auth.token.cookie_token, `/get_reg_act_fertil_azotada_tres_5d_cabecalho/${cabecalho?.id_act_feertil_azotada}`);
            if (res.status === 200) {

                setRowsOrganica(res.data.result);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("getOrganica", error, true);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (async () => {
            if (cabecalho !== undefined) {
                if (obj_organica === undefined) {
                    await getOrganica();
                } else {
                    setRowsOrganica([obj_organica])
                }
            } else {
                setIsLoading(false)
            }
        })();
    }, [cabecalho, obj_organica]);

    const handle_fechar_nova_linha_limpar_campos = () => {
        set_obj_editar(undefined);
        setCreateTable(false);
        set_error_ferti_B(false)
    }
    // Criar
    const onInputChange = (event: any) => {
        const { name, value } = event.target;
        set_flag_editado(true)

        if (name === "ferti_B") {

            if (/[a-zA-Z]/.test(value)) {
                set_error_ferti_B(true);

            } else {
                set_error_ferti_B(false);
                let aux_value1 = format_strings_to_numbers(value)
                let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0

                let aux_a_b = obj_editar?.ferti_A === undefined ? 0 : calcula_b_A(aux_value, obj_editar.ferti_A)
                set_obj_editar((prevManeio: any) => ({
                    ...prevManeio,
                    ['B_A']: aux_a_b,
                    ['ferti_B']: format_strings_to_numbers(value, false),
                }));
            }
        } else {
            set_obj_editar((prevManeio: any) => ({
                ...prevManeio,
                [name]: value,
            }));
        }
    };

    const handleSaveOrganica = async () => {
        try {
            setIsLoading(true);

            let res = await post(auth.token.cookie_token, "new_reg_act_fertil_azotada_tres_5d", {
                payload: {
                    id_registo_fertil_tres: 0,
                    ferti_A: obj_editar?.ferti_A === undefined ? 0 : obj_editar.ferti_A,
                    ferti_B: obj_editar?.ferti_B === undefined ? 0 : obj_editar.ferti_B,
                    B_A: obj_editar?.B_A === undefined ? null : obj_editar.B_A,
                    tres_dois: obj_editar?.tres_dois === undefined ? null : obj_editar.tres_dois,
                    tres_um: obj_editar?.tres_um === undefined ? null : obj_editar.tres_um,
                    quatro_um_um: obj_editar?.quatro_um_um === undefined ? null : obj_editar.quatro_um_um,
                    quatro_um_dois: obj_editar?.quatro_um_dois === undefined ? null : obj_editar.quatro_um_dois,
                    quatro_um_tres: obj_editar?.quatro_um_tres === undefined ? null : obj_editar.quatro_um_tres,
                    quatro_um_quatro: obj_editar?.quatro_um_quatro === undefined ? null : obj_editar.quatro_um_quatro,
                    quatro_dois_um: obj_editar?.quatro_dois_um === undefined ? null : obj_editar.quatro_dois_um,
                    quatro_dois_dois: obj_editar?.quatro_dois_dois === undefined ? null : obj_editar.quatro_dois_dois,
                    id_act_feertil_azotada: cabecalho?.id_act_feertil_azotada,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: "",
                }
            });

            if (res.status === 200) {
                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);
                setRowsOrganica((rows) => [...rows, res.data.result]);
                setCreateTable(false);
                set_flag_editado(false)

            } else {
                setMessage("Erro ao gravar!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error: any) {
            func_print("handleSaveOrganica", error, true);
            if (error?.status === 409) {

                setMessage(error?.response.data.detail);
                setOpenSnackError(true);
            } else {
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }

            setIsLoading(false);
        }
    };

    const handleSaveEdit = async () => {
        try {

            let res = await post(auth.token.cookie_token, `update_reg_act_fertil_azotada_tres_5d`, {
                payload: {
                    id_registo_fertil_tres: obj_editar?.id_registo_fertil_tres,
                    ferti_A: obj_editar?.ferti_A === undefined ? null : obj_editar.ferti_A,
                    ferti_B: obj_editar?.ferti_B === undefined ? null : obj_editar.ferti_B,
                    B_A: obj_editar?.B_A === undefined ? null : obj_editar.B_A,
                    tres_dois: obj_editar?.tres_dois === undefined ? null : obj_editar.tres_dois,
                    tres_um: obj_editar?.tres_um === undefined ? null : obj_editar.tres_um,
                    quatro_um_um: obj_editar?.quatro_um_um === undefined ? null : obj_editar.quatro_um_um,
                    quatro_um_dois: obj_editar?.quatro_um_dois === undefined ? null : obj_editar.quatro_um_dois,
                    quatro_um_tres: obj_editar?.quatro_um_tres === undefined ? null : obj_editar.quatro_um_tres,
                    quatro_um_quatro: obj_editar?.quatro_um_quatro === undefined ? null : obj_editar.quatro_um_quatro,
                    quatro_dois_um: obj_editar?.quatro_dois_um === undefined ? null : obj_editar.quatro_dois_um,
                    quatro_dois_dois: obj_editar?.quatro_dois_dois === undefined ? null : obj_editar.quatro_dois_dois,
                    id_act_feertil_azotada: obj_editar?.id_act_feertil_azotada,
                    last_update: new Date().toISOString(),
                    create_date: new Date().toISOString(),
                    uuid: "",
                }
            });

            if (res.status === 200) {
                setMessage("Registado com sucesso!");
                const updatedRows = rowsOrganica.map((row) =>
                    row.id_registo_fertil_tres === res.data.result.id_registo_fertil_tres
                        ? res.data.result
                        : row
                );
                setRowsOrganica(updatedRows !== undefined ? updatedRows : []);
                set_obj_editar(undefined);
                setOpenSnackSuccess(true);
                set_flag_editado(false)

            } else {
                setMessage("Erro ao atualizar o cabeçalho!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error: any) {
            func_print("handleSaveEdit", error, true);
            if (error?.status === 409) {

                setMessage(error?.response.data.detail);
                setOpenSnackError(true);
            } else {
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }

            setIsLoading(false);
        }
    };

    // DELETE
    const handleClickOpenDeleteOrganica = (obj: IFertilizacaoOrganica) => {
        set_obj_editar(obj);
        setOpenDeleteOrganica(true);

    };
    const handleDeleteOrganica = async () => {
        try {
            let res = await del(auth.token.cookie_token, `delete__reg_act_fertil_azotada_tres_5d/${obj_editar?.id_registo_fertil_tres}`);

            if (res.status === 200) {
                setMessage("Eliminado com sucesso!");

                set_obj_editar(undefined);
                setOpenDeleteOrganica(false);
                setRowsOrganica((rows) => [...rows.filter((row) => row.id_registo_fertil_tres !== obj_editar?.id_registo_fertil_tres)]);

                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao eliminar!");
                setOpenSnackError(true);
            }
            setIsLoading(false);

        } catch (error) {
            func_print("handleClickOpenDeleteOrganica", error, true);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    return (
        <CustomThemeProvider>
            {isLoading ?
                <LoadingVulpes /> :
                <TableContainer
                    component={Paper}
                    variant="outlined"
                    sx={{ height: "auto", width: "auto", margin: 2, padding: 2, }}
                >
                    <Snackbar
                        open={openSnackSuccess}
                        autoHideDuration={2000}
                        onClose={() => setOpenSnackSuccess(false)}
                    >
                        <Alert
                            onClose={() => setOpenSnackSuccess(false)}
                            severity="success"
                            sx={{ width: "100%" }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                    <Snackbar
                        open={openSnackError}
                        autoHideDuration={2000}
                        onClose={() => setOpenSnackError(false)}
                    >
                        <Alert
                            onClose={() => setOpenSnackError(false)}
                            severity="error"
                            sx={{ width: "100%" }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                    <table style={{ width: "100%" }}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCellCabecalho colSpan={6} sx={{ fontWeight: 600, fontSize: 16 }} >
                                    <Stack direction="row" justifyContent="start" alignItems="center">
                                        3 - Nível de fertilização orgânica
                                        <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica»."} />
                                    </Stack>
                                </StyledTableCellCabecalho>
                                {rowsOrganica.length === 0 && createTable === false ? (
                                    <TableCell colSpan={5}>
                                        <Stack direction="row" justifyContent="end">
                                            {is_historico === true ? <></> :

                                                <BarraDeFerramentas
                                                    mostrarBotaoNovo
                                                    textoBotaoNovo="Registar"
                                                    aoClicarNovo={() => {

                                                        setCreateTable(true)
                                                        set_obj_editar(undefined)

                                                    }}
                                                />}
                                        </Stack>
                                    </TableCell>
                                ) : (
                                    createTable === true && (
                                        <TableCell colSpan={5}>
                                            <ButtonCadernos
                                                mostrarBotaoCancelar
                                                aoClicarCancelar={() => {
                                                    if (flag_editado) {
                                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                    } else {
                                                        handle_fechar_nova_linha_limpar_campos()
                                                    }
                                                }}
                                                mostrarBotaoGravar
                                                aoClicarGravar={() => handleSaveOrganica()}
                                            />
                                        </TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>

                        {createTable ? (
                            <TableBody>
                                <TableRow>
                                    <StyledTableHead colSpan={2} width="30%" sx={{ backgroundColor: "lightgray" }}>
                                        (A) = Fertilização N(total) (kg/ha)
                                    </StyledTableHead>
                                    <StyledTableHead width="15%" sx={{ backgroundColor: "lightgray" }} >
                                        {obj_editar?.ferti_A === undefined ? "" : obj_editar.ferti_A.toString().replace('.', ',')}
                                    </StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead colSpan={2} sx={{ backgroundColor: "lightgray" }}>
                                        (B)= Fertilização de N Total Orgânico de: efluentes
                                        pecuários, seus equiparados, sua mistura ou composto de
                                        efluentes pecuários (kg/ha)
                                        <BasicPopover
                                            text={"Para determinar o valor de (B) o beneficiário deve somar todos os valores individuais registados no campo «Quantidade total de azoto (NTotal) aplicada» do Quadro «1 - Quantidades de azoto aplicadas» provenientes de efluentes pecuários, seus equiparados, sua mistura ou compostos de efluentes pecuários.\n Ou seja, ao TOTAL do campo «Quantidade total de azoto (NTotal) aplicada» do Quadro 1 deve ser subtraído o azoto proveniente dos fertilizantes de síntese."} />
                                    </StyledTableHead>
                                    <StyledTableHead>
                                        <CustomTextField
                                            name="ferti_B"
                                            value={obj_editar?.ferti_B === undefined ? "" : obj_editar.ferti_B.toString().replace('.', ',')}
                                            onChange={onInputChange}
                                            error={error_ferti_B}
                                            helperText={error_ferti_B ? message_apenas_numero : ""}
                                        />
                                    </StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead colSpan={2}>(B)/(A) (%)</StyledTableHead>
                                    <StyledTableHead>
                                        {obj_editar?.B_A === undefined ? "" : obj_editar.B_A.toString().replace('.', ',')}
                                    </StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} >
                                        {"   3.1 - Nível de fertilização orgânica ≥25% e <50%?"}
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção\n da fertilização orgânica».\n Beneficiário deve preencher esta questão de acordo com o resultado\n obtido no campo (B)/(A) do Quadro «2 - Nível de fertilização orgânica».\n\nValores possíveis:\n- Sim;\n- Não."} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.tres_um === undefined ? "" : obj_editar.tres_um}
                                            name="tres_um"
                                            onChange={onInputChange}
                                            options={confirm}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16 }} >
                                        3.2 - Nível de fertilização orgânica ≥50%?
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção\n da fertilização orgânica».\n Beneficiário deve preencher esta questão de acordo com o resultado\n obtido no campo (B)/(A) do Quadro «2 - Nível de fertilização orgânica».\n\nValores possíveis:\n- Sim;\n- Não."} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.tres_dois === undefined ? "" : obj_editar.tres_dois}
                                            name="tres_dois"
                                            onChange={onInputChange}
                                            options={confirm}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} align="center" sx={{ fontWeight: 600, fontSize: 16, paddingTop: 10 }} >
                                        4 - Práticas adotadas na valorização agrícola dos
                                        efluentes pecuários
                                    </StyledTableCellCabecalho>
                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 3 }} >
                                        4.1 - Chorume
                                    </StyledTableCellCabecalho>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 6 }} >
                                        4.1.1 - Aplicou chorume?
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica».\nO beneficiário deverá responder: \n - Sim;\n- Não. \n\nEm caso de resposta afirmativa deverá responder às questão 3.1.2, 3.1.3 e 3.1.4."} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.quatro_um_um === undefined ? "" : obj_editar.quatro_um_um}
                                            name="quatro_um_um"
                                            onChange={onInputChange}
                                            options={confirm}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 6 }} >
                                        4.1.2 - Qual o equipamento usado para a aplicação de
                                        chorume?
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1.\n\nValores possíveis:\n- Equipamento a baixa pressão; \n- Equipamento de injeção direta;\n- Outro tipo de equipamento.."} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.quatro_um_dois === undefined ? "" : obj_editar.quatro_um_dois}
                                            name="quatro_um_dois"
                                            onChange={onInputChange}
                                            options={tres_um_dois}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 6 }} >
                                        4.1.3 - Qual o tempo decorrido para a incorporação de
                                        chorume no solo?
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1. \n\nValores possíveis:\n- Chorume incorporado até 4 horas após a distribuição; \n- Chorume incorporado mais de 4 horas após a distribuição* \n\n(*) - De acordo com o n.º 21, do artigo 10º da Portaria n.º 259/2012, de 28 de agosto, o período de intervalo de tempo\n entre a distribuiçao e a incorporação de chorume, pode ser superior a 4 horas,\n desde que a sua aplicação cumpra simultaneamente as seguintes condições: \n 1) Aplicação e cobertura ou em sementeira direta sem injeção; \n 2) Seguida de rega controlada em tempo seco."} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.quatro_um_tres === undefined ? "" : obj_editar.quatro_um_tres}
                                            name="quatro_um_tres"
                                            onChange={onInputChange}
                                            options={tres_um_tres}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 6 }} >
                                        4.1.4 - Qual a fase do processo produtivo em que aplicou
                                        chorume?
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1. \n\n  Valores possíveis: \n - Antes da sementeira (em fundo);\n- Em sementeira direta;\n- Sobre cultura já instalada (em cobertura). "} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.quatro_um_quatro === undefined ? "" : obj_editar.quatro_um_quatro}
                                            name="quatro_um_quatro"
                                            onChange={onInputChange}
                                            options={tres_um_quatro}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 3 }} >
                                        4.2 - Estrume ou outro fertilizante orgânico (FO, alínea
                                        b) do n.º 1 do artigo 31º) exceto chorume
                                    </StyledTableCellCabecalho>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 6 }}>
                                        4.2.1 - Aplicou estrume ou outra F.O. (exceto chorume)?
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica». \n O beneficiário deverá responder: \n - Sim; \n - Não. \n\n Em caso de resposta afirmativa deverá responder à questão 3.2.2."} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.quatro_dois_um === undefined ? "" : obj_editar.quatro_dois_um}
                                            name="quatro_dois_um"
                                            onChange={onInputChange}
                                            options={confirm}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={5} sx={{ fontWeight: 600, fontSize: 16, paddingLeft: 6 }}>
                                        4.2.2 - Qual o tempo decorrido para a incorporação de
                                        estrume ou outro FO no solo?
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>
                                        <Stack direction="row" justifyContent="right" alignItems="center">
                                            <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.2.1. \n\n  Valores possíveis: \n - Estrume ou outra F.O. incorporado até 24 horas após a distribuição; \n - Estrume ou outra F.O. incorporado mais de 24 horas após a distribuição."} />
                                        </Stack>
                                        <CustomSelect
                                            value={obj_editar?.quatro_dois_dois === undefined ? "" : obj_editar.quatro_dois_dois}
                                            name="quatro_dois_dois"
                                            onChange={onInputChange}
                                            options={tres_dois_dois}
                                            label={"Selecione"}
                                            minWidth={120}
                                        />
                                    </StyledTableCell>
                                </TableRow>
                            </TableBody>
                        ) : (
                            rowsOrganica.length === 0 &&
                            createTable === false &&
                            (
                                <TableBody>
                                    <TableRow>
                                        <StyledTableHead colSpan={2} width="30%" sx={{ backgroundColor: "lightgray" }}>
                                            (A) = Fertilização N(total) (kg/ha)
                                        </StyledTableHead>
                                        <StyledTableHead width="15%" sx={{ backgroundColor: "lightgray" }} ></StyledTableHead>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead colSpan={2} sx={{ backgroundColor: "lightgray" }} >
                                            (B)= Fertilização de N Total Orgânico de: efluentes
                                            pecuários, seus equiparados, sua mistura ou composto
                                            de efluentes pecuários (kg/ha)
                                            <BasicPopover text={"Para determinar o valor de (B) o beneficiário deve somar todos os valores individuais registados no campo «Quantidade total de azoto (NTotal) aplicada» do Quadro «1 - Quantidades de azoto aplicadas» provenientes de efluentes pecuários, seus equiparados, sua mistura ou compostos de efluentes pecuários. Ou seja, ao TOTAL do campo «Quantidade total de azoto (NTotal) aplicada» do Quadro 1 deve ser subtraído o azoto proveniente dos fertilizantes de síntese."} />
                                        </StyledTableHead>
                                        <StyledTableHead></StyledTableHead>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead colSpan={2}> (B)/(A) (%) </StyledTableHead>
                                        <StyledTableHead></StyledTableHead>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            {"   3.1 - Nível de fertilização orgânica ≥25% e <50%?"}
                                        </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção\n da fertilização orgânica».\n Beneficiário deve preencher esta questão de acordo com o resultado\n obtido no campo (B)/(A) do Quadro «2 - Nível de fertilização orgânica».\n\nValores possíveis:\n- Sim;\n- Não."} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            3.2 - Nível de fertilização orgânica ≥50%?
                                        </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção\n da fertilização orgânica».\n Beneficiário deve preencher esta questão de acordo com o resultado\n obtido no campo (B)/(A) do Quadro «2 - Nível de fertilização orgânica».\n\nValores possíveis:\n- Sim;\n- Não."} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5} align="center">
                                            4 - Práticas adotadas na valorização agrícola dos
                                            efluentes pecuários
                                        </StyledTableCellCabecalho>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>4.1 - Chorume</StyledTableCellCabecalho>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}> 4.1.1 - Aplicou chorume? </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica».\nO beneficiário deverá responder: \n - Sim;\n- Não. \n\nEm caso de resposta afirmativa deverá responder às questão 3.1.2, 3.1.3 e 3.1.4."} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            4.1.2 - Qual o equipamento usado para a aplicação de
                                            chorume?
                                        </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1.\n\nValores possíveis:\n- Equipamento a baixa pressão; \n- Equipamento de injeção direta;\n- Outro tipo de equipamento.."} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            4.1.3 - Qual o tempo decorrido para a incorporação de
                                            chorume no solo?
                                        </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1. \n\nValores possíveis:\n- Chorume incorporado até 4 horas após a distribuição; \n- Chorume incorporado mais de 4 horas após a distribuição* \n\n(*) - De acordo com o n.º 21, do artigo 10º da Portaria n.º 259/2012, de 28 de agosto, o período de intervalo de tempo\n entre a distribuiçao e a incorporação de chorume, pode ser superior a 4 horas,\n desde que a sua aplicação cumpra simultaneamente as seguintes condições: \n 1) Aplicação e cobertura ou em sementeira direta sem injeção; \n 2) Seguida de rega controlada em tempo seco."} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            4.1.4 - Qual a fase do processo produtivo em que
                                            aplicou chorume?
                                        </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1. \n\n  Valores possíveis: \n - Antes da sementeira (em fundo);\n- Em sementeira direta;\n- Sobre cultura já instalada (em cobertura). "} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            4.2 - Estrume ou outro fertilizante orgânico (FO,
                                            alínea b) do n.º 1 do artigo 31º) exceto chorume
                                        </StyledTableCellCabecalho>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            4.2.1 - Aplicou estrume ou outra F.O. (exceto
                                            chorume)?
                                        </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica». \n O beneficiário deverá responder: \n - Sim; \n - Não. \n\n Em caso de resposta afirmativa deverá responder à questão 3.2.2."} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCellCabecalho colSpan={5}>
                                            4.2.2 - Qual o tempo decorrido para a incorporação de
                                            estrume ou outro FO no solo?
                                        </StyledTableCellCabecalho>
                                        <StyledTableCell>
                                            <Stack direction="row" justifyContent="right" alignItems="center">
                                                <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.2.1. \n\n  Valores possíveis: \n - Estrume ou outra F.O. incorporado até 24 horas após a distribuição; \n - Estrume ou outra F.O. incorporado mais de 24 horas após a distribuição."} />
                                            </Stack>
                                        </StyledTableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        )}




                        {rowsOrganica.map((row, index) => {

                            if (obj_editar?.id_registo_fertil_tres === row.id_registo_fertil_tres) {

                                return (
                                    <TableBody key={index}>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Stack direction="row" justifyContent="end">
                                                    <ButtonCadernos
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => handleSaveEdit()}
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                            } else {
                                                                handle_fechar_nova_linha_limpar_campos()
                                                            }
                                                        }}
                                                    />
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key={row.id_registo_fertil_tres}>
                                            <StyledTableHead colSpan={2} width="30%" sx={{ backgroundColor: "lightgray" }} >
                                                (A) = Fertilização N(total) (kg/ha)
                                            </StyledTableHead>
                                            <StyledTableHead width="15%" sx={{ backgroundColor: "lightgray" }} >
                                                {obj_editar?.ferti_A === undefined || obj_editar?.ferti_A === null ? "" : obj_editar.ferti_A.toString().replace('.', ',')}

                                            </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead
                                                colSpan={2} sx={{ backgroundColor: "lightgray" }} >
                                                (B)= Fertilização de N Total Orgânico de:
                                                efluentes pecuários, seus equiparados, sua
                                                mistura ou composto de efluentes pecuários
                                                (kg/ha)
                                                <BasicPopover text={"Para determinar o valor de (B) o beneficiário deve somar todos os valores individuais registados no campo «Quantidade total de azoto (NTotal) aplicada» do Quadro «1 - Quantidades de azoto aplicadas» provenientes de efluentes pecuários, seus equiparados, sua mistura ou compostos de efluentes pecuários. Ou seja, ao TOTAL do campo «Quantidade total de azoto (NTotal) aplicada» do Quadro 1 deve ser subtraído o azoto proveniente dos fertilizantes de síntese."} />
                                            </StyledTableHead>
                                            <StyledTableHead>
                                                <CustomTextField
                                                    name="ferti_B"
                                                    value={obj_editar?.ferti_B === undefined || obj_editar?.ferti_B === null ? "" : obj_editar.ferti_B.toString().replace('.', ',')}

                                                    onChange={onInputChange}
                                                    error={error_ferti_B}
                                                    helperText={error_ferti_B ? message_apenas_numero : ""}
                                                />
                                            </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead colSpan={2}> (B)/(A) (%) </StyledTableHead>
                                            <StyledTableHead>
                                                {obj_editar?.B_A === undefined || obj_editar?.B_A === null ? "" : obj_editar.B_A.toString().replace('.', ',')}

                                            </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}  >
                                                {"   3.1 - Nível de fertilização orgânica ≥25% e <50%?"}
                                            </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center">
                                                    <BasicPopover
                                                        text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção\n da fertilização orgânica».\n Beneficiário deve preencher esta questão de acordo com o resultado\n obtido no campo (B)/(A) do Quadro «2 - Nível de fertilização orgânica».\n\nValores possíveis:\n- Sim;\n- Não."} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.tres_um === undefined ? "" : obj_editar.tres_um}

                                                    name="tres_um"
                                                    onChange={onInputChange}
                                                    options={confirm}
                                                    label={"Selecione"}
                                                    minWidth={120} />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}> 3.2 - Nível de fertilização orgânica ≥50%? </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center" >
                                                    <BasicPopover
                                                        text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção\n da fertilização orgânica».\n Beneficiário deve preencher esta questão de acordo com o resultado\n obtido no campo (B)/(A) do Quadro «2 - Nível de fertilização orgânica».\n\nValores possíveis:\n- Sim;\n- Não."} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.tres_dois === undefined ? "" : obj_editar.tres_dois}
                                                    name="tres_dois"
                                                    onChange={onInputChange}
                                                    options={confirm}
                                                    label={"Selecione"}
                                                    minWidth={120} />
                                            </StyledTableCell>
                                        </TableRow>
                                        <StyledTableRow>
                                            <StyledTableCellCabecalho colSpan={5} align="center">
                                                4 - Práticas adotadas na valorização
                                                agrícola dos efluentes pecuários
                                            </StyledTableCellCabecalho>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCellCabecalho colSpan={5}> 4.1 - Chorume  </StyledTableCellCabecalho>
                                        </StyledTableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}> 4.1.1 - Aplicou chorume? </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center">
                                                    <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica».\nO beneficiário deverá responder: \n - Sim;\n- Não. \n\nEm caso de resposta afirmativa deverá responder às questão 3.1.2, 3.1.3 e 3.1.4."} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.quatro_um_um === undefined ? "" : obj_editar.quatro_um_um}
                                                    name="quatro_um_um"
                                                    onChange={onInputChange}
                                                    options={confirm}
                                                    label={"Selecione"}
                                                    minWidth={120} />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.1.2 - Qual o equipamento usado para a
                                                aplicação de chorume?
                                            </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center">
                                                    <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1.\n\nValores possíveis:\n- Equipamento a baixa pressão; \n- Equipamento de injeção direta;\n- Outro tipo de equipamento.."} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.quatro_um_dois === undefined ? "" : obj_editar.quatro_um_dois}
                                                    name="quatro_um_dois"
                                                    onChange={onInputChange}
                                                    options={tres_um_dois}
                                                    label={"Selecione"}
                                                    minWidth={120} />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.1.3 - Qual o tempo decorrido para a
                                                incorporação de chorume no solo?
                                            </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center">
                                                    <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1. \n\nValores possíveis:\n- Chorume incorporado até 4 horas após a distribuição; \n- Chorume incorporado mais de 4 horas após a distribuição* \n\n(*) - De acordo com o n.º 21, do artigo 10º da Portaria n.º 259/2012, de 28 de agosto, o período de intervalo de tempo\n entre a distribuiçao e a incorporação de chorume, pode ser superior a 4 horas,\n desde que a sua aplicação cumpra simultaneamente as seguintes condições: \n 1) Aplicação e cobertura ou em sementeira direta sem injeção; \n 2) Seguida de rega controlada em tempo seco."} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.quatro_um_tres === undefined ? "" : obj_editar.quatro_um_tres}
                                                    name="quatro_um_tres"
                                                    onChange={onInputChange}
                                                    options={tres_um_tres}
                                                    label={"Selecione"} />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.1.4 - Qual a fase do processo produtivo em
                                                que aplicou chorume?
                                            </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center" >
                                                    <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.1.1. \n\n  Valores possíveis: \n - Antes da sementeira (em fundo);\n- Em sementeira direta;\n- Sobre cultura já instalada (em cobertura). "} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.quatro_um_quatro === undefined ? "" : obj_editar.quatro_um_quatro}
                                                    name="quatro_um_quatro"
                                                    onChange={onInputChange}
                                                    options={tres_um_quatro}
                                                    label={"Selecione"}
                                                    minWidth={120} />
                                            </StyledTableCell>
                                        </TableRow>
                                        <StyledTableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.2 - Estrume ou outro fertilizante orgânico
                                                (FO, alínea b) do n.º 1 do artigo 31º)
                                                exceto chorume
                                            </StyledTableCellCabecalho>
                                        </StyledTableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.2.1 - Aplicou estrume ou outra F.O.
                                                (exceto chorume)?
                                            </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center">
                                                    <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica». \n O beneficiário deverá responder: \n - Sim; \n - Não. \n\n Em caso de resposta afirmativa deverá responder à questão 3.2.2."} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.quatro_dois_um === undefined ? "" : obj_editar.quatro_dois_um}
                                                    name="quatro_dois_um"
                                                    onChange={onInputChange}
                                                    options={confirm}
                                                    label={"Selecione"}
                                                    minWidth={120} />
                                            </StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.2.2 - Qual o tempo decorrido para a
                                                incorporação de estrume ou outro FO no solo?
                                            </StyledTableCellCabecalho>
                                            <StyledTableCell>
                                                <Stack direction="row" justifyContent="right" alignItems="center">
                                                    <BasicPopover text={"Preenchimento obrigatório apenas no âmbito do regime ecológico «promoção da fertilização orgânica» e se o beneficiário respondeu 'Sim' à questão 3.2.1. \n\n  Valores possíveis: \n - Estrume ou outra F.O. incorporado até 24 horas após a distribuição; \n - Estrume ou outra F.O. incorporado mais de 24 horas após a distribuição."} />
                                                </Stack>
                                                <CustomSelect
                                                    value={obj_editar?.quatro_dois_dois === undefined ? "" : obj_editar.quatro_dois_dois}
                                                    name="quatro_dois_dois"
                                                    onChange={onInputChange}
                                                    options={tres_dois_dois}
                                                    label={"Selecione"}
                                                    minWidth={120}
                                                />
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableBody>
                                );
                            } else {
                                return (
                                    <TableBody key={index}>
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Stack direction="row" justifyContent="end">
                                                    {is_historico === true ? <></> :

                                                        <ButtonCadernos
                                                            mostrarBotaoEditar
                                                            aoClicarEditar={() => {
                                                                set_obj_editar(row);
                                                                set_error_ferti_B(false);
                                                                setCreateTable(false)
                                                            }}
                                                        // mostrarBotaoApagar
                                                        // aoClicarApagar={() => handleClickOpenDeleteOrganica(row)}
                                                        />}
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead
                                                colSpan={2} width="30%" sx={{ backgroundColor: "lightgray" }} >
                                                <Stack direction="row" justifyContent="center" alignItems="center">
                                                    (A) = Fertilização N(total) (kg/ha)
                                                    <BasicPopover text={"Campo de preenchimento automático e que corresponde ao TOTAL do campo \n «Quantidade total de azoto (NTotal) aplicada» do Quadro «1 - Quantidades de azoto aplicadas»."} />
                                                </Stack>
                                            </StyledTableHead>
                                            <StyledTableHead width="15%" sx={{ backgroundColor: "lightgray" }} >
                                                {formatarNumero_recebido_com_casa_decimais(row.ferti_A)}
                                            </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead colSpan={2} sx={{ backgroundColor: "lightgray" }}>
                                                (B)= Fertilização de N Total Orgânico de:
                                                efluentes pecuários, seus equiparados, sua
                                                mistura ou composto de efluentes pecuários
                                                (kg/ha)
                                                <BasicPopover text={"Para determinar o valor de (B) o beneficiário deve somar todos os valores individuais registados no campo «Quantidade total de azoto (NTotal) aplicada» do Quadro «1 - Quantidades de azoto aplicadas» provenientes de efluentes pecuários, seus equiparados, sua mistura ou compostos de efluentes pecuários.\n Ou seja, ao TOTAL do campo «Quantidade total de azoto (NTotal) aplicada» do Quadro 1 deve ser subtraído o azoto proveniente dos fertilizantes de síntese."}
                                                />
                                            </StyledTableHead>
                                            <StyledTableHead>{formatarNumero_recebido_com_casa_decimais(row.ferti_B)} </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableHead colSpan={2} sx={{ backgroundColor: "lightgray" }} >
                                                (B)/(A) (%)
                                            </StyledTableHead>
                                            <StyledTableHead>{formatarNumero_recebido_com_casa_decimais(row.B_A)}</StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>
                                        </TableRow>
                                        <TableRow >
                                            <StyledTableCellCabecalho colSpan={5}>
                                                {"3.1 - Nível de fertilização orgânica ≥25% e <50%?"}
                                            </StyledTableCellCabecalho>
                                            <StyledTableHead>{row.tres_um}</StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                3.2 - Nível de fertilização orgânica ≥50%?
                                            </StyledTableCellCabecalho>
                                            <StyledTableHead>{row.tres_dois} </StyledTableHead>
                                        </TableRow>
                                        <StyledTableRow>
                                            <StyledTableCellCabecalho colSpan={5} align="center" >
                                                4 - Práticas adotadas na valorização
                                                agrícola dos efluentes pecuários
                                            </StyledTableCellCabecalho>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCellCabecalho colSpan={5}> 4.1 - Chorume</StyledTableCellCabecalho>
                                        </StyledTableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>4.1.1 - Aplicou chorume? </StyledTableCellCabecalho>
                                            <StyledTableHead> {row.quatro_um_um} </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.1.2 - Qual o equipamento usado para a
                                                aplicação de chorume?
                                            </StyledTableCellCabecalho>
                                            <StyledTableHead>{row.quatro_um_dois} </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.1.3 - Qual o tempo decorrido para a
                                                incorporação de chorume no solo?
                                            </StyledTableCellCabecalho>
                                            <StyledTableHead> {row.quatro_um_tres} </StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.1.4 - Qual a fase do processo produtivo
                                                em que aplicou chorume?
                                            </StyledTableCellCabecalho>
                                            <StyledTableHead>{row.quatro_um_quatro} </StyledTableHead>
                                        </TableRow>

                                        <StyledTableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.2 - Estrume ou outro fertilizante
                                                orgânico (FO, alínea b) do n.º 1 do artigo
                                                31º) exceto chorume
                                            </StyledTableCellCabecalho>
                                        </StyledTableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.2.1 - Aplicou estrume ou outra F.O. (exceto chorume)?
                                            </StyledTableCellCabecalho>
                                            <StyledTableHead> {row.quatro_dois_um}</StyledTableHead>
                                        </TableRow>
                                        <TableRow>
                                            <StyledTableCellCabecalho colSpan={5}>
                                                4.2.2 - Qual o tempo decorrido para a
                                                incorporação de estrume ou outro FO no
                                                solo?
                                            </StyledTableCellCabecalho>
                                            <StyledTableHead> {row.quatro_dois_dois} </StyledTableHead>
                                        </TableRow>
                                    </TableBody>

                                )
                            }

                        })}
                    </table>
                </TableContainer>
            }
            <ConfirmDialog
                open={openDeleteOrganica}
                onClose={() => setOpenDeleteOrganica(false)}
                onConfirm={handleDeleteOrganica}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </CustomThemeProvider>
    );


}

